import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__wrapper" }
const _hoisted_3 = { class: "header__content" }
const _hoisted_4 = { class: "header__logo" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "header__block" }
const _hoisted_7 = { class: "header__profile" }

import { IAppSetting } from '@/@types/config';

// Modules
import { ref, computed } from 'vue';
import { useConfig } from '@/composables/config';

// Composables
import { useRouter } from 'vue-router';

// Components
import SmMainMenu from '@/components/common/SmMainMenu/SmMainMenu.vue'
import SmIcon from '@/components/ui/SmIcon/SmIcon.vue'
// import SmBadge from '@/components/ui/SmBadge/SmBadge.vue'
import SmProfileDropdown from '@/components/layout/SmProfileDropdown/SmProfileDropdown.vue';

// Styles
import '@/layouts/SmHeader/style.scss'

// [START] Composables

export default /*#__PURE__*/_defineComponent({
  __name: 'SmHeader',
  setup(__props) {

const router = useRouter();
const { getAppSettings } = useConfig();

const appSettings: IAppSetting = getAppSettings();

// [START] Variables
// const notificationsCount = ref<number>(6);
const showProfileDropdown = ref<boolean>(false);
// [END] Variables

const appLogo = computed((): string => appSettings.appIconFile || '');

const organizationName = computed((): string => appSettings.main_name || '');


// [START] Methods
const handleToggleDropdown = () => {
  showProfileDropdown.value = !showProfileDropdown.value
}
const handleProfileDropdownClickout = () => {
  showProfileDropdown.value = false
}
const handleOpenSupportChat = () => {
  // TODO: router.push
  router.push({
    name: 'TechSupport'
  });
}
// [END] Methods

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: appLogo.value,
            alt: organizationName.value,
            width: "32",
            height: "32"
          }, null, 8, _hoisted_5)
        ]),
        _createVNode(SmMainMenu, { class: "header__menu" }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SmIcon, {
            name: "Operator",
            size: "24",
            class: "header__chat",
            onClick: handleOpenSupportChat
          }),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "header__profile-icon-wrap",
              onClick: handleToggleDropdown
            }, [
              _createVNode(SmIcon, {
                name: "User",
                size: "24",
                class: "header__profile-icon"
              })
            ]),
            _createVNode(SmProfileDropdown, {
              modelValue: showProfileDropdown.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showProfileDropdown).value = $event)),
              class: "header__profile-dropdown"
            }, null, 8, ["modelValue"])
          ])), [
            [_directive_click_outside, handleProfileDropdownClickout]
          ])
        ])
      ])
    ])
  ]))
}
}

})